var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBellOffNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_325_3234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 20.0001H3.99994C3.90709 20.0001 3.81607 19.9742 3.73708 19.9254C3.65809 19.8766 3.59426 19.8067 3.55273 19.7237C3.5112 19.6406 3.49363 19.5476 3.50196 19.4552C3.5103 19.3627 3.54423 19.2744 3.59994 19.2001L3.99994 18.6671V10.0001C3.99994 8.67007 4.32394 7.41607 4.89894 6.31307L1.39294 2.80807L2.80794 1.39307L22.6069 21.1931L21.1919 22.6071L18.5859 20.0001ZM6.40794 7.82207C6.13756 8.51634 5.99919 9.255 5.99994 10.0001V18.0001H16.5859L6.40794 7.82207ZM19.9999 15.7861L17.9999 13.7861V10.0001C18.0001 8.94773 17.7236 7.91386 17.1979 7.00218C16.6723 6.09051 15.9162 5.33311 15.0054 4.80599C14.0946 4.27886 13.0612 4.00055 12.0089 3.99899C10.9565 3.99742 9.9223 4.27265 9.00994 4.79707L7.55994 3.34507C8.76468 2.54128 10.165 2.07961 11.6116 2.0093C13.0581 1.93899 14.4966 2.26268 15.7736 2.94584C17.0506 3.629 18.1182 4.646 18.8626 5.88835C19.6069 7.1307 20 8.55181 19.9999 10.0001V15.7861ZM9.49994 21.0001H14.4999C14.4999 21.6631 14.2366 22.299 13.7677 22.7678C13.2989 23.2367 12.663 23.5001 11.9999 23.5001C11.3369 23.5001 10.701 23.2367 10.2322 22.7678C9.76334 22.299 9.49994 21.6631 9.49994 21.0001Z",
    fill: "#007AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_325_3234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBellOffNew);
export default __webpack_public_path__ + "static/media/notification_bell_off_new.089ec360.svg";
export { ForwardRef as ReactComponent };